import type { Candidate } from '@axiom/validation';
import { useApi } from '@axiom/ui';

import { CandidateApi } from '../api/candidate-api';
import { OpportunityLegacyApi } from '../api/opportunity-legacy-api';
import { UserApi } from '../api/user-api';
import { UserTalentApi } from '../api/user-talent-api';
import { TalentTagsApi } from '../api/talent-tags-api';

export const useRefreshCandidate = (candidateId: Candidate['id']) => {
  const [{ data: sessionUser }] = useApi(UserApi.readSessionUser());

  const refreshCandidate = async (id = candidateId) => {
    // Refresh grid caches so changes appear without a page reload
    // (BACK-7469): Talent grid (/talent) and My Bench grid (/bench) both
    // cache their result sets and need to be invalidated.
    void CandidateApi.refreshCandidates();
    if (sessionUser.id) {
      void UserTalentApi.refreshUserTalent(sessionUser.id);
    }
    void TalentTagsApi.refreshCandidateTags(id);
    // (BACK-7353): the Evaluating Talent side card on opportunity-detail reads
    // calculatedDisplayName from OpportunityLegacyApi.readOpportunityCandidates;
    // invalidate every cached opportunity candidates list (the candidate may
    // sit on multiple opportunities) so name/status edits surface without a
    // hard refresh.
    void OpportunityLegacyApi.invalidateAll();
    return CandidateApi.refreshCandidate({ candidateId: id }); // refresh api cache
  };

  return {
    refreshCandidate,
  };
};
